/** ENUMS **/
export var Datakilde;
(function (Datakilde) {
    Datakilde["CORE_SUITE"] = "CORE_SUITE";
    Datakilde["F2100"] = "F2100";
})(Datakilde || (Datakilde = {}));
export var AnswerState;
(function (AnswerState) {
    AnswerState["ANSWERED"] = "ANSWERED";
    AnswerState["UNANSWERED"] = "UNANSWERED";
})(AnswerState || (AnswerState = {}));
export var Spareformål;
(function (Spareformål) {
    Spareformål["PENSJON"] = "PENSJON";
    Spareformål["BARN_BARNEBARN"] = "BARN_BARNEBARN";
    Spareformål["SPESIFIKT_M\u00C5L"] = "SPESIFIKT_M\u00C5L";
    Spareformål["IKKE_SPESIFIKT_M\u00C5L"] = "IKKE_SPESIFIKT_M\u00C5L";
})(Spareformål || (Spareformål = {}));
export var RaadgivningType;
(function (RaadgivningType) {
    RaadgivningType["SELVBETJENT_FONDSKONTO_PENSJON"] = "SELVBETJENT_FONDSKONTO_PENSJON";
    RaadgivningType["SELVBETJENT_FONDSKONTO_ANNEN_SPARING"] = "SELVBETJENT_FONDSKONTO_ANNEN_SPARING";
})(RaadgivningType || (RaadgivningType = {}));
export var EgnethetQuestionKey;
(function (EgnethetQuestionKey) {
    EgnethetQuestionKey["TIDSHORISONT"] = "TIDSHORISONT";
    EgnethetQuestionKey["RISIKOPREFERANSE"] = "RISIKOPREFERANSE";
    EgnethetQuestionKey["RISIKO_VERDIREDUKSJON"] = "RISIKO_VERDIREDUKSJON";
    EgnethetQuestionKey["RISIKO_VERDISVINGNING"] = "RISIKO_VERDISVINGNING";
})(EgnethetQuestionKey || (EgnethetQuestionKey = {}));
export var FatcaQuestionKey;
(function (FatcaQuestionKey) {
    FatcaQuestionKey["VELG_SKATTEPLIKTIG_LAND_2"] = "VELG_SKATTEPLIKTIG_LAND_2";
    FatcaQuestionKey["SKATTENUMMER_2"] = "SKATTENUMMER_2";
    FatcaQuestionKey["SKATTEPLIKTIG_LAND"] = "SKATTEPLIKTIG_LAND";
    FatcaQuestionKey["VELG_SKATTEPLIKTIG_LAND"] = "VELG_SKATTEPLIKTIG_LAND";
    FatcaQuestionKey["SKATTENUMMER"] = "SKATTENUMMER";
    FatcaQuestionKey["SKATTEPLIKTIG_USA"] = "SKATTEPLIKTIG_USA";
    FatcaQuestionKey["AMERIKANSK_STATSBORGER"] = "AMERIKANSK_STATSBORGER";
    FatcaQuestionKey["NORSK_STATSBORGER"] = "NORSK_STATSBORGER";
    FatcaQuestionKey["INVESTERT_KAPITAL"] = "INVESTERT_KAPITAL";
    FatcaQuestionKey["STOR_INVESTERING"] = "STOR_INVESTERING";
    FatcaQuestionKey["POLITISK_EKSPONERT"] = "POLITISK_EKSPONERT";
})(FatcaQuestionKey || (FatcaQuestionKey = {}));
export var Fondskategori;
(function (Fondskategori) {
    Fondskategori["AKSJEFOND"] = "AKSJEFOND";
    Fondskategori["RENTEFOND"] = "RENTEFOND";
})(Fondskategori || (Fondskategori = {}));
export var Risikoprofil;
(function (Risikoprofil) {
    Risikoprofil["TRYGG"] = "TRYGG";
    Risikoprofil["BALANSERT"] = "BALANSERT";
    Risikoprofil["OFFENSIV"] = "OFFENSIV";
    Risikoprofil["ALDERSTILPASSET"] = "ALDERSTILPASSET";
})(Risikoprofil || (Risikoprofil = {}));
export var TimeHorizon;
(function (TimeHorizon) {
    TimeHorizon["SHORT"] = "SHORT";
    TimeHorizon["LONG"] = "LONG";
})(TimeHorizon || (TimeHorizon = {}));
export var RoutePath;
(function (RoutePath) {
    RoutePath["LOGIN"] = "/";
    RoutePath["CONTENT"] = "/content";
    RoutePath["KONTO"] = "/konto";
    RoutePath["AMOUNT"] = "/spare";
    RoutePath["RAADGIVNING_EGNETHET"] = "/kartlegging";
    RoutePath["RAADGIVNING_FATCA"] = "/opplysninger";
    RoutePath["ANBEFALT_PROFIL"] = "/anbefaling";
    RoutePath["PROFIL"] = "/profil";
    RoutePath["ABOUT"] = "/kunde";
    RoutePath["SUMMARY"] = "/bekreft";
})(RoutePath || (RoutePath = {}));
/** TYPES **/
export const FEATURE_FLAG_APP = 'gpf_fkl_';
export const defaultFeatureFlags = {
    opprettPrivatprodukterICoreSuite: true,
};
/** ACTIONS **/
export var Action;
(function (Action) {
    // GLOBAL ACTIONS
    Action["SET_CUSTOMER_NAME"] = "SET_CUSTOMER_NAME";
    Action["UPDATE_SELLER_REF"] = "UPDATE_SELLER_REF";
    Action["UPDATE_SIGNING_PARAMS"] = "UPDATE_SIGNING_PARAMS";
    Action["UPDATE_SIGN_RESULT"] = "UPDATE_SIGN_RESULT";
    Action["SHOW_PERSONVERN_MODAL"] = "SHOW_PERSONVERN_MODAL";
    Action["SHOW_PROFIL_INFO_MODAL"] = "SHOW_PROFIL_INFO_MODAL";
    // FORM ACTIONS
    Action["SUBMIT_KONTOOPPLYSNINGER"] = "SUBMIT_KONTOOPPLYSNINGER";
    Action["SUBMIT_CUSTOMER_DATA"] = "SUBMIT_CUSTOMER_DATA";
    Action["UPDATE_UTBETALINGSDETALJER"] = "UPDATE_UTBETALINGSDETALJER";
    Action["UPDATE_AMOUNT_DATA"] = "UPDATE_AMOUNT_DATA";
    Action["SUBMIT_VALGT_RISIKOPROFIL"] = "SUBMIT_VALGT_RISIKOPROFIL";
    Action["SUBMIT_RAADGIVNING_DATA"] = "SUBMIT_RAADGIVNING_DATA";
    Action["SUBMIT_IDD_ANBEFALING"] = "SUBMIT_IDD_ANBEFALING";
    Action["SUBMIT_PORTEF\u00D8LJE_FOR_ALLE_PROFILER"] = "SUBMIT_PORTEF\u00D8LJE_FOR_ALLE_PROFILER";
    Action["SUBMIT_CUSTOM_PAYOUT_AGE"] = "SUBMIT_CUSTOM_PAYOUT_AGE";
})(Action || (Action = {}));
